/**
 * Classe représentant une exécution de procédure travel lors d'un changement d'état du DV par API
 *
 * @author Laurent Convert
 * @date 16/04/2025
 */
export class ProcedureDvStatut {
	statut: Statut;
	dateExecution: Date;
}

export enum Statut {
	OK = 'OK',
	ERROR = 'ERROR'
}
